import React from 'react';

export default function WeatherCorner({ weather }) {
  if (!weather) return null;
  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px', zIndex: 900,
      fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--ink-light)',
      letterSpacing: '0.1em', lineHeight: 1.6,
      textAlign: 'right', pointerEvents: 'none',
      opacity: 0.6,
    }}>
      <div>BOS · {weather.label}</div>
      {weather.temp !== null && <div>{weather.temp}°F</div>}
    </div>
  );
}
